<template>
  <v-app>
      <v-container fluid>

        <v-select
        v-model="grafica_seleccionada"
        :items="items"
        item-text="name"
        item-value="id"
        >
        </v-select>
        <div class="mt-3 pl-2 pr-2">
          <div>
            <span class="display-1">{{titulo}}</span>
           
          
            <!--Leyenda Gráfica-->
            <v-layout class="mt-1">
              <v-flex xs12>
                <line-chart-sin-lineas
                    :unidades="unidadesGrafica"
                    :chart-data="datosGrafica"
                    :linea="100"
                ></line-chart-sin-lineas>
              </v-flex>
            </v-layout>
          </div>

          <!--Leyenda inferior-->
          <!-- <v-row class="text-center mt-2 blue-grey--text"> 
              <v-col>
                <v-icon color="#FF9800">mdi-information</v-icon> SECADO
              </v-col>      
              <v-col>
                <v-icon color="#2196F3">mdi-information</v-icon> HIGIENIZACIÓN 
              </v-col>  
              <v-col title="Tiempo en alcanzar los 80º">         
                <v-icon>mdi-alarm</v-icon> {{calcularTiempoSecado()}} 
              </v-col>                      
          </v-row> -->

          <!--TABLA CON INFO ADICIONAL-->
          <v-divider class="mt-2" color="#CFD8DC"/>
          <v-data-table
            class="mt-4"
              :headers="headers"
              disable-sort
              hide-default-footer
              :items="infoAdicional">

              <template v-slot:[`item.temperatura`]>{{temperatura}}</template> 
              <template v-slot:[`item.consigna`]>{{consigna}}</template>
              <template v-slot:[`item.operario`]>{{operario}}</template>
              <template v-slot:[`item.lote`]>{{lote}}</template>
              <template v-slot:[`item.kilos`]>{{kilos}}</template>
              <template v-slot:[`item.enMarcha`]>
                <div v-if="enMarcha">
                  SÍ
                </div>
                <div v-else>
                  NO
                </div>
                </template>
              <template v-slot:[`item.calentando`]>
                <div v-if="calentando">
                  SÍ
                </div>
                <div v-else>
                  NO
                </div>
                </template>
             
          </v-data-table> 
        </div>
      </v-container>
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
// import moment from 'vue-moment';
import moment from 'moment-timezone';


import LineChartSinLineas from '@/components/LineChartSinLineas.vue'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
} from 'chart.js'
ChartJS.register(  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale)

  export default {
    name: 'Home',
    components: {
      LineChartSinLineas
    },
    //FIN DE COMPONENTES
    watch:{
      grafica_seleccionada(){
        if(this.grafica_seleccionada){
          this.reiniciar_datos()
          this.mostrar_previos()
        }
      }
    },
    //FIN DE PROPIEDADES
    data() {
      return {
        grafica_seleccionada:1,
        items:[
          {'id':1,name:'Horno 1'},
          {'id':2,name:'Horno 2'},
          {'id':3,name:'Horno 3'},
        ],
        horno1: {},
        horno2: {},
        horno3: {},
        previos:{},
        temperatura:'',
        consigna:'-',
        operario:'-',
        lote:'-',
        kilos:'-',
        fase:'-',
        enMarcha:false,
        calentando:false,
        mensajes:{
          datos:[],
          estados:[]
        },
        infoAdicional:[],
        headers:[
            {
              text:"TEMPERATURA",
              align:"center",
              value:"temperatura"
            },
            {
                text:"Consigna",
                align:"center",
                value:"consigna"
            },  
            {
                text:"Trabajador",
                align:"center",
                value:"operario"
            },
            {
                text:"Lote",
                align:"center",
                value:"lote"
            },
            {
                text:"Kg",
                align:"center",
                value:"kilos"
            },
            { text:"En marcha", align:"center", value:"enMarcha" }, 
            { text:"Calentando", align:"center", value:"calentando" },
          ],
        ultimoEnsayo: -1,
      }
    },

    //FIN DE DATOS
    methods: {
       ...mapActions("eggnovo",['set_previos_horno','set_fallo_hignienizacion1','set_fallo_hignienizacion2','set_cicloDia','set_horaCicloAnterior']),
       ...mapActions("nodered",['doPublish','doSubscribe']),

      tratar_datos(mensaje){
        // console.log(`ESTE ES UN MENSAJE DE ENSAYO: ${mensaje}`)
        //Limpiar buffer de temperaturas
        let a = JSON.parse(mensaje)
        // console.log(a);
        if(a[`horno${this.grafica_seleccionada}`]){
          this.mensajes.datos.push({fecha:a.fecha, temperatura: a[`horno${this.grafica_seleccionada}`].temperatura})
          this.infoAdicional[0] = a[`horno${this.grafica_seleccionada}`]
          this.operario = a[`horno${this.grafica_seleccionada}`].hasOwnProperty("operario")?a[`horno${this.grafica_seleccionada}`].operario:'-'
          this.lote = a[`horno${this.grafica_seleccionada}`].hasOwnProperty("lote")?a[`horno${this.grafica_seleccionada}`].lote:'-'
          this.temperatura = a[`horno${this.grafica_seleccionada}`].hasOwnProperty("temperatura")?a[`horno${this.grafica_seleccionada}`].temperatura.toFixed(2):'?'
          this.consigna = a[`horno${this.grafica_seleccionada}`].hasOwnProperty("consigna")?a[`horno${this.grafica_seleccionada}`].consigna:'-'
          this.kilos = a[`horno${this.grafica_seleccionada}`].hasOwnProperty("kilos")?a[`horno${this.grafica_seleccionada}`].kilos:'-'
          this.enMarcha =a[`horno${this.grafica_seleccionada}`].hasOwnProperty("enMarcha")?a[`horno${this.grafica_seleccionada}`].enMarcha:'-'
          this.calentando = a[`horno${this.grafica_seleccionada}`].hasOwnProperty("calentando")?a[`horno${this.grafica_seleccionada}`].calentando:'-'
        }
       
        // if(a.estado==0){
        //   this.mensajes.datos = []
        // }
      },
      tratar_previos(mensaje){
        this.previos = JSON.parse(mensaje)
        console.log("los previos: ",this.previos);
      },
      mostrar_previos(){
        let a = this.previos_horno
        if(a[`horno${this.grafica_seleccionada}`]){
          console.log("Si que existeeeeeeeeeeeeeeeeee");

          this.mensajes.datos = a[`horno${this.grafica_seleccionada}`].hasOwnProperty("datos")?a[`horno${this.grafica_seleccionada}`].datos:[]
          this.operario = a[`horno${this.grafica_seleccionada}`].hasOwnProperty("operario")?a[`horno${this.grafica_seleccionada}`].operario:'-'
          this.lote = a[`horno${this.grafica_seleccionada}`].hasOwnProperty("lote")?a[`horno${this.grafica_seleccionada}`].lote:'-'
          this.consigna = a[`horno${this.grafica_seleccionada}`].hasOwnProperty("consigna")?a[`horno${this.grafica_seleccionada}`].consigna:'-'
          this.temperatura = a[`horno${this.grafica_seleccionada}`].hasOwnProperty("temperatura")?a[`horno${this.grafica_seleccionada}`].temperatura.toFixed(2):'?'
          this.kilos = a[`horno${this.grafica_seleccionada}`].hasOwnProperty("kilos")?a[`horno${this.grafica_seleccionada}`].kilos:'-'
          this.enMarcha =a[`horno${this.grafica_seleccionada}`].hasOwnProperty("enMarcha")?a[`horno${this.grafica_seleccionada}`].enMarcha:false
          this.calentando = a[`horno${this.grafica_seleccionada}`].hasOwnProperty("calentando")?a[`horno${this.grafica_seleccionada}`].calentando:false
        }
      },
      reiniciar_datos(){
        this.infoAdicional[0]={
          'temperatura':'-',
          'consigna':'-',
          'operario':'-',
          'lote':'-',
          'kilos':'-',
          'fase':'-',
          'calentando':false,
          'enMarcha':false,
        }
        this.temperatura ='-'
        this.operario ='-'
        this.lote = '-'
        this.consigna = '-'
        this.kilos = '-'
        this.enMarcha =false
        this.calentando = false
        console.log("reiniciado!");
      },
      // tratar_produccion(mensaje){
      //   // console.log(`ESTE ES UN MENSAJE DE temperatura: ${mensaje}`)
      //   const b = JSON.parse(mensaje)
      //   this.mensajes.datos.push(b)
      //   // console.log(b)
      //   this.ultima_fase=b.fase;
      //   this.fecha = b.fecha
      //   // console.log('Se añadio la temperatura')
      // },    
      eliminar_caracteres(fecha){
        let nueva = ''
        nueva = fecha.substring(11,23)
        let nueva2 = nueva.replace(/:/g,'')
        nueva2 = Math.round(nueva2)
        return nueva2
      },  
      getTimeFromDate(fecha){
        return fecha.split('T')[1].substring(0,8);
      },   
      parseDia(){
          let result = ''
          if(this.mensajes.datos.length==0)
            return result
          let primera_temp = this.mensajes.datos[0].fecha
          return primera_temp
      },

      calcularTiempoSecado() {
        let result = []
        this.mensajes.datos.map(item => {
            if(item.fase == '2'){
                result.push(item)
            }
        })

        return this.segundosAminutos(result.length)
      },

      segundosAminutos(duration){   
          // Hours, minutes and seconds
          var hrs = ~~(duration / 3600);
          var mins = ~~((duration % 3600) / 60);
          var secs = ~~duration % 60;

          // Output like "1:01" or "4:03:59" or "123:03:59"
          var ret = "";

          if (hrs > 0) {
              ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
          }

          ret += "" + mins + ":" + (secs < 10 ? "0" : "");
          ret += "" + secs;
          return ret;
      },

      roundToTwo(num) {
        return +(Math.round(num + "e+2")  + "e-2");
      },

      diaAnterior(){
        const yesterday = new Date()
        yesterday.setDate(yesterday.getDate() - 1)
        return this.formatDate(yesterday)
      },

      padTo2Digits(num) {
        return num.toString().padStart(2, '0');
      },

      formatDate(date) { // yyyy-mm-dd
        return [
          date.getFullYear(),
          this.padTo2Digits(date.getMonth() + 1),
          this.padTo2Digits(date.getDate()),
        ].join('/');
      },

    
     
    },
    //FIN DE METODOS
    computed:{
      ...mapState('eggnovo',[
        'higienizacion1',
        'higienizacion2',
        'tiempoFalloHigienizacion1',
        'tiempoFalloHigienizacion2',
        'cicloDia',
        'horaCicloAnterior',
        'previos_horno'
      ]),
      ...mapState("nodered", ["client"]),
      ...mapGetters("eggnovo",['getHornoPrevios']),
      //Fase del último mensaje recibido
      last_fase(){
        let resultado='-'
       
        switch (this.ultima_fase) {
          case 0:
            resultado='CERO'
            break;
          case 1:
            resultado='OBTENIENDO DATOS DE CICLO'
            break;
          case 2:
            resultado='SECADO'
            break;
          case 3:
            resultado='HIGIENIZACIÓN 1'
            break;
          case 4:
            resultado='HIGIENIZACIÓN 2'
            break;
          case 10:
            resultado='FIN DE CICLO'
            break;
        
          default:
            break;
        }
        return resultado
      },
      ultimo_estado(){
        let resultado='-'
        //Comprobación fase de higienización 1 por cada segundo
        if(this.ultima_temperatura_tromel < this.higienizacion1.temperaturaUmbral){
          this.set_fallo_hignienizacion1() 
        }
        //Comprobación fase de higienización 2
        if(this.ultima_temperatura_tromel < this.higienizacion2.temperaturaUmbral){
          this.set_fallo_hignienizacion2() 
        }

        // resultado = (this.tiempoFalloHigienizacion1 > this.higienizacion1.tiempoUmbral) ? 'FALLO HIGIENIZACION 1' : 'CORRECTO'
        // resultado = (this.tiempoFalloHigienizacion2 > this.higienizacion2.tiempoUmbral) ? 'FALLO HIGIENIZACION 2' : 'CORRECTO'

        if(this.tiempoFalloHigienizacion1 < this.higienizacion1.tiempoUmbral){ //Higienizacion1 OK
          if(this.tiempoFalloHigienizacion2 < this.higienizacion2.tiempoUmbral){ //Higienizacion2 OK
            resultado = 'CORRECTO'
          }else{
            resultado = 'FALLO HIGIENIZACION 2'
          }
        }else{
          resultado = 'FALLO HIGIENIZACION 1'
        }

        return resultado
      },
      ultima_temperatura_salida (){
        if (this.mensajes.datos.length < 1) return '?'
        return this.roundToTwo(this.mensajes.datos.slice(-1)[0].dato.Out_AI_Temp_Salida_Resistencias)
      }, 
      ultimo_caudal_aire (){
        if (this.mensajes.datos.length < 1) return '?'
        return this.roundToTwo(this.mensajes.datos.slice(-1)[0].dato.Out_AI_Caudal_Aire)
      }, 
      ultima_temperatura_tromel (){
        if (this.mensajes.datos.length < 1) return '?'
        return this.roundToTwo(this.mensajes.datos.slice(-1)[0].dato.Out_AI_Temp_Tromel)
      }, 
      titulo(){
        return this.items.find(a=>a.id==this.grafica_seleccionada).name;// [this.grafica_seleccionada].name
      },

      //Monstrará una imagen en rojo cuando baje de 80° en fase 2
      no_ok(){
        return this.mensajes.datos.filter(a=>a.dato<80 && a.fase===2).length>0
      },
      //Pintar los puntos en el gráfico    
      tempGrafico()
      {
        let nuevo={
          labels:[],
          datasets:[
            {
              data:[],
              segment:{
                  borderColor: '#FF9800',
                },
              pointRadius: 0, //No pintar los puntos (para que solo se vea la linea)
            },
            ]} 

            //************************************DATOS DE PRUEBA ***************/
            // this.numEnsayo = 10
            // this.lote = 99
            // this.trabajador = "JOSE LUIS MARTINEZ"
            // this.mensajes.datos = [
            // {fecha:'2022-06-10T11:19:41+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:1},
            // {fecha:'2022-06-10T11:19:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:2},
            // {fecha:'2022-06-10T11:21:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:2},
            // {fecha:'2022-06-10T11:22:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:2},
            // {fecha:'2022-06-10T11:23:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:2},
            // {fecha:'2022-06-10T11:24:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:2},
            // {fecha:'2022-06-10T11:25:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:2},
            // {fecha:'2022-06-10T11:26:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:3},
            // {fecha:'2022-06-10T11:27:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:3},
            // {fecha:'2022-06-10T11:28:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:3},
            // {fecha:'2022-06-10T11:29:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:3}]
            // //********************************************************************* */    
           
            
            this.mensajes.datos.forEach(element => {
              let prueba = new Date(element.fecha.replace(' ', 'T'));
              
              let a = moment(prueba).format('HH:mm:ss')
              // if(element[`horno${this.grafica_seleccionada}`]){
                nuevo.datasets[0].data.push({'x':a,'y':element['temperatura']})
              // }
            nuevo.labels.push(a)
            });   
            nuevo.consigna = typeof this.consigna === 'number'?this.consigna:null
          return nuevo
      },

      // tempSalidaResistenciasGrafico()
      // {
      //   let nuevo={
      //     labels:[],
      //     datasets:[
      //       {
      //         data:[],
      //         segment:{
      //                   borderColor: ctx => this.choosePhaseColor(ctx),
      //                 },
      //         pointRadius: 0, //No pintar los puntos (para que solo se vea la linea)
      //       },
      //       ]} 

  
      //       this.mensajes.datos.forEach(element => {
      //           let prueba = new Date(element.fecha.replace(' ', 'T'));

      //         let a = moment(prueba).format('HH:mm:ss')
             


      //       nuevo.datasets[0].data.push({'x':a,'y':element.dato.Out_AI_Temp_Salida_Resistencias,'fase':element.fase})
      //       nuevo.labels.push(a)
      //       });       
      //     return nuevo
      // },
      // caudalGrafico()
      // {
      //   let nuevo={
      //     labels:[],
      //     datasets:[
      //       {
      //         data:[],
      //         segment:{
      //                   borderColor: ctx => this.choosePhaseColor(ctx),
      //                 },
      //         pointRadius: 0, //No pintar los puntos (para que solo se vea la linea)
      //       },
      //       ]} 

  
      //       this.mensajes.datos.forEach(element => {
      //         let prueba = new Date(element.fecha.replace(' ', 'T'));

      //         let a = moment(prueba).format('HH:mm:ss')

             
      //       nuevo.datasets[0].data.push({'x':a,'y':element.dato.Out_AI_Caudal_Aire,'fase':element.fase})
      //       nuevo.labels.push(a)
      //       });       
      //     return nuevo
      // },

      //Dibujar gráfica en función de lo seleccionado:
      datosGrafica(){
        return this.tempGrafico
      },

      unidadesGrafica(){
          return "ºC"
      }
    }, //FIN DE COMPUTADOS

    mounted(){
      console.log(this.getHornoPrevios);
      this.mostrar_previos()
    },
    //AL ARRANCAR EL PROYECTO ME SUSCRIBO A DOS CANALES
    created() {
      console.log("CREADO");
      //Se suscribe al topic produccion para recibir los datos de producción
      this.reiniciar_datos()
     
      //Previamente ya estaba suscrito a los topic de ensayos y PREVIOS
      //Cuando reciba un mensaje se debe diferenciar el topic desde el que llega
      this.client.on('message', (topic, message) => {
        //Datos relativos al ensayo (realizado por, lote MP, lote bolson, Cuerpos extraños,kg membrana y lote membrana)
        if(topic=="hornos"){
          this.tratar_datos(message)

        //Obtiene todos los datos de producción del ciclo actual (al cargar la página)
        }else if(topic== "hornos_previo"){
          this.set_previos_horno(message)
          this.mostrar_previos()
        }
      
      })

    }, //FIN DE CREAR
    
  }
</script>

<style>
  .texto {
    text-align: center;
    background-color: rgb(230, 230, 230);
    font-size: 2em;
  }
  .icono{
    text-align: center;
    font-size: 2em;
  }
</style>